import * as constants from './constants';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import * as selectors from './selectors';
import reducer from './reducer';
import MyReportsGrid from './components/MyReportsGrid';
import ComplianceReportsGrid from './components/ComplianceReportsGrid';
import ReportsGrid from './components/ReportsGrid';
import ReportDetails from './components/ReportDetails';
import DelegatedWaitingForApprovalReportsGrid from './components/DelegatedWaitingForApprovalReportsGrid';
import WaitingForApprovalReportsGrid from './components/WaitingForApprovalReportsGrid';

export default {
    constants, reducer, actions, actionTypes, selectors,
    MyReportsGrid, ComplianceReportsGrid, ReportDetails, ReportsGrid, WaitingForApprovalReportsGrid, DelegatedWaitingForApprovalReportsGrid
}